import React from 'react';
import { Helmet } from "react-helmet";
import { Col, Row, Container } from 'reactstrap';
// Local Deps
import './Contact.scss';
import msgs from '../../../config/messages';

export default function Contact() {
  return (
    <Container>
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Contact Us Page</title>
        <meta name="description" content="The ICON Portal is managed by the Non-Ferrous Founders' Society, a North American foundry trade association." />
        <meta name="keywords" content="NFFS, NFFS phone number, AMC, contact NFFS" />
      </Helmet>
      <div className="nf-contact">
        <h1 className="nf-contact__header">{msgs.Contact.header}</h1>
        <Row>
          <Col xs={12}>
            <div className="nf-contact__section-text">
              {msgs.Contact.section1.text}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h4 className="nf-contact__section-header">
              {msgs.Contact.section2.header}
            </h4>
            <address className="nf-contact__address">
              <p className="nf-contact__address-item nf-contact__address-item--caps">
                <strong>{msgs.Contact.address.name}</strong>
              </p>
              <p className="nf-contact__address-item">
                <strong>{msgs.Contact.address.company}</strong>
              </p>
              <p className="nf-contact__address-item">
                {msgs.Form.phoneLabel}
                <a href={`tel:${msgs.Contact.address.phone}`} >{msgs.Contact.address.phone}</a>

              </p>
              <p className="nf-contact__address-item">
                {msgs.Form.faxLabel}{msgs.Contact.address.fax}
              </p>
              <p className="nf-contact__address-item">
                {msgs.Form.emailLabel}
                <a href={`mailto:${msgs.Contact.address.email}`} target="_blank">
                  {msgs.Contact.address.email}
                </a>
              </p>
            </address>
          </Col>
        </Row>
      </div>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/pages/static/Contact/Contact.jsx